module.exports = __webpack_public_path__ + "8d91c3a7c433d7dd6a6f66174e19e964.glb";